import { useModal } from '@billy/design-system'
import { Button, Icon, Menu } from '@shinetools/lumen-react'
import { ChevronDown, CloudUpload, Plus } from 'lucide-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ContactsImportModal } from '@views/contacts/elements/ContactsList/elements/ContactsImportModal'

import { ModalId } from '../../../../enums/modalId'

const importModalId = ModalId.ContactsImportModal

interface SuppliersAddMenuProps {
  onCreateManuallySelect: () => void
}

export const SuppliersAddMenu = ({ onCreateManuallySelect }: SuppliersAddMenuProps): ReactElement => {
  const { t } = useTranslation()
  const { open: openImportModal } = useModal(importModalId)

  const handleCreateManuallyClick = () => {
    onCreateManuallySelect()
  }

  const handleImportSuppliersClick = () => {
    openImportModal()
  }

  return (
    <>
      <Menu
        placement="bottom-end"
        trigger={<Button endIcon={<Icon icon={ChevronDown} />} label={t('suppliers.list.add_supplier')} />}
      >
        <Menu.Item
          icon={<Icon icon={Plus} />}
          label={t('suppliers.list.create_manually')}
          onClick={handleCreateManuallyClick}
        />
        <Menu.Item
          icon={<Icon icon={CloudUpload} />}
          label={t('suppliers.list.import_suppliers')}
          onClick={handleImportSuppliersClick}
        />
      </Menu>
      <ContactsImportModal
        descriptionHint={t('suppliers.list.import_description_hint')}
        id={importModalId}
        title={t('suppliers.list.import_modal_title')}
      />
    </>
  )
}
